import { httpRequest } from '@v4/http/request';
import { getApiUrl } from '@v4/config';
import { stringifyUrl } from '@v4/common/utils/url';

export const baseUrl = `${getApiUrl()}/dkwp/v3/configurator`;
export const offersBaseUrl = `${getApiUrl()}/dkwp/v3/offers/configurator`;

/**
 * Gets the submodel versions
 *
 * @param {string} make make name
 * @param {string} model model name
 * @returns {Promise<object>}
 */

export const fetchVersions = (make, model, query) =>
    httpRequest({ url: stringifyUrl({ url: `${baseUrl}/${make}/${model}`, query }) });

/**
 * Gets the offers for a configurator version
 *
 * @param {string} makeName make name
 * @param {string|number} submodelId submodel identifier
 * @param {string} versionNameUrlCode version name url code
 * @returns {Promise<object>}
 */
export const fetchVersionOffers = (makeName, submodelId, versionNameUrlCode, query) =>
    httpRequest({
        url: stringifyUrl({
            url: `${offersBaseUrl}/${makeName}/${submodelId}/${versionNameUrlCode}/`,
            query,
        }),
    });
